<template>
    <div class="animated fadeIn" v-if="satisfiedDependencies">
        <b-row class="py-2">
            <b-card header="Editar Categoría de Consulta" class="w-100">
                <query-category-form
                    :queryCategory="queryCategory"
                    :queryCategories="queryCategories"
                    :renderDeleteButton="mixinCheckPermission('QUERY_CATEGORY_DELETE')"
                    :renderSaveButton="mixinCheckPermission('QUERY_CATEGORY_EDIT')"
                    @submit-query-category="updateQueryCategory($event)"
                    @delete-query-category="deleteQueryCategory">
                </query-category-form>
            </b-card>
        </b-row>
    </div>
</template>

<script>
    import QueryCategoryForm from '@/components/queries/categories/QueryCategoryForm';
    import {
        getQueryCategories,
        getQueryCategory,
        updateQueryCategory,
        deleteQueryCategory
    } from '@/api/query-category-api';

    export default {
        name: "edit-query-category",
        components: {
            QueryCategoryForm
        },
        mounted() {
            this.$eventHub.$emit('captureMenu', this.topmenu);
            this.getQueryCategory();
            this.getQueryCategories();
        },
        data: function () {
            return {
                topmenu: [
                    {
                        name: 'Volver',
                        path: '/queries/categories/list',
                        brand: 'fa fa-arrow-left'
                    },
                ],
                queryCategories: [],
                queryCategoriesRequestDone: false,
                queryCategory: {
                    uuid: null,
                    name: null,
                    parent: null,
                    children: []
                }
            };
        },
        computed: {
            satisfiedDependencies() {
                return this.queryCategoriesRequestDone && !!this.queryCategory.uuid;
            }
        },
        methods: {
            async getQueryCategories() {
                this.$_loadingMixin_showLoading();
                await getQueryCategories()
                    .then((queryCategories) => {
                        this.queryCategories = queryCategories;
                        this.queryCategoriesRequestDone = true;
                    });
                this.$_loadingMixin_hideLoading();
            },
            async getQueryCategory() {
                this.$_loadingMixin_showLoading();
                await getQueryCategory(this.$route.params.uuid)
                    .then((queryCategory) => {
                        this.queryCategory = queryCategory;
                    });
                this.$_loadingMixin_hideLoading();
            },
            updateQueryCategory(queryCategory) {
                this.$_loadingMixin_showLoading();

                let parentId = null;
                if (!!queryCategory.parent && !!queryCategory.parent.uuid) {
                    parentId = queryCategory.parent.uuid;
                }

                updateQueryCategory(this.$route.params.uuid, {
                    name: queryCategory.name,
                    parentId: parentId
                })
                    .then(() => {
                        this.$_notificationMixin_success('Operación Completada', 'Realizado con éxito');
                        this.$_loadingMixin_hideLoading();
                        this.$router.push({path: '/queries/categories/list'});
                    })
                    .catch(() => {
                        this.$_notificationMixin_error('Operación denegada', 'Algo salió mal');
                        this.$_loadingMixin_hideLoading();
                    });
            },
            deleteQueryCategory() {

                swal({
                    title: '¿Estás seguro de eliminar esta categoría?', text: "Esta operación no se podrá revertir", type: 'warning',
                    showCancelButton: true, cancelButtonText: 'Cancelar', confirmButtonText: 'Sí, elimínala!'
                }).then((result) => {
                    if (result.value) {

                        this.$_loadingMixin_showLoading();
                        deleteQueryCategory(this.$route.params.uuid)
                            .then(() => {
                                this.$_notificationMixin_success('Operación Completada', 'Realizado con éxito');
                                this.$_loadingMixin_hideLoading();
                                this.$router.push({path: '/queries/categories/list'});
                            })
                            .catch(() => {
                                this.$_notificationMixin_error('Operación denegada', 'Algo salió mal');
                                this.$_loadingMixin_hideLoading();
                            });

                    }
                });

            }
        }
    }
</script>

<style scoped>

</style>